import React from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";
import ImageText1 from "../../components/ImageText1";
import ImageText2 from "../../components/ImageText2";
import Footer from "../../components/Footer";
import backgroundImage from "../../assets/images/crossborderrecruitment/bg-recruitment.jpg";
import imageUrl from "../../assets/images/Play IT 1.png";
import imageUrl2 from "../../assets/images/crossborderrecruitment/recruitment-section2.jpg";
// import Partners from "../home/Partners1";
function CrossborderRecruitment() {
  const welcomeHeading = "Crossborder Recruitment en detachering";

  const imageTextHeading =
    "De kracht van de juiste medewerker op de juiste plek!";
  const imageTextText = (
    <>
      {/* <span style={{ fontWeight: "bold" }}>
        Ons werving- en selectieproces is transparant en flexibel. Directe werving- en selectie, of in combinatie met een voorafgaande detacheringsperiode, alles is mogelijk.
      </span> */}
      Ons werving- en selectieproces is transparant en flexibel. Directe
      werving- en selectie, of in combinatie met een voorafgaande
      detacheringsperiode, alles is mogelijk.
      <br />
      Wanneer u op zoek bent naar de juiste kandidaat voor een positie binnen uw
      bedrijf, kunnen wij u hierbij helpen. Wij beschikken over een uitgebreide
      database van specialisten, variërend van recent afgestudeerde kandidaten
      tot ervaren krachten. Of het nu gaat om een productiemedewerker,
      pijpfitter, mechanical supervisor, procurement lead of HR Professional,
      wij vinden de geschikte kandidaat voor u. Wij zijn gevestigd in Nederland
      en België en kunnen dan ook over deze landsgrenzen heen passende
      kandidaten leveren.
    </>
  );

  const imageTextText2 = (
    <>
      {/* <span style={{ fontWeight: "bold" }}>
        Mocht u meer informatie willen neemt u dan contact met ons op!
      </span>
      <br /> */}
      Wanneer u voor een kortere periode op zoek bent naar een interim
      professional is dat ook mogelijk. Wij beschikken over een uitgebreide
      database van professionals die u kunnen bijstaan voor een korte of
      middellange periode. Uiteraard zorgen wij er dan voor dat dit in Nederland
      voldoet aan de Wet DBA, zodat u op dit vlak geen risico loopt.
      <br />
      Bent u tijdelijk op zoek naar Commissioning Engineers, Procurement Leads,
      SHE Professionals, HR Managers of Projectmanagers: wij ontzorgen u graag!{" "}
      <br />
      <b>
        Professionals kunnen zich inschrijven. Zie formulier bovenin de balk
      </b>
    </>
  );
  // const imageTextText3 = (
  //   <>
  //     <span style={{ fontWeight: "bold" }}>
  //       ONTSNAP AAN HET TRAININGSDILEMMA
  //     </span>
  //     <br />
  //     <br />
  //     Optimaliseren met game-based learning
  //     <br />
  //     <br />
  //     Hebben tijdrovende, dure en complexe leermethoden je in de steek gelaten?
  //     Win tijd terug en houd de aandacht vast met game-based learning. Hectische
  //     schema's, Verstoringen van het werk, Zoeken naar experts, En onzekerheid
  //     over retentie van opleidingsinhoud, Klinkt dat bekend? Even voorstellen:
  //     Play IT, het ultieme platform voor game-based learning - efficiënt leren
  //     op maat van je schema, altijd en overal. Doe gewoon mee aan korte,
  //     boeiende en realistische games. Klaar om een level omhoog te gaan?
  //   </>
  // );

  // const backgroundColor = "#D9D9D9";
  // const textColor = "black";

  return (
    <div>
      <Helmet>
        <title>Crossborder Recruitment en detachering</title>
        <meta
          name="description"
          content="Ontdek beter leren met DD-Group en Play-IT! Onze op games gebaseerde trainingen maken leren leuk en effectief. Neem contact met ons op om Play-IT te verbinden voor op maat gemaakte trainingsoplossingen die aan je behoeften voldoen."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <ImageText1
            imageUrl={imageUrl}
            heading={imageTextHeading}
            text={imageTextText}
          />
          <ImageText2
            imageUrl={imageUrl2}
            text={imageTextText2}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          {/* <Partners /> */}
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default CrossborderRecruitment;
